import styled, { keyframes } from 'styled-components';
import { timingFunctions, transparentize } from 'polished';
import PropTypes from 'prop-types';
import { brandColors } from 'styles/colors';

const fadeInAndScale = keyframes`
	from { opacity: 0; transform: scale(0.925) }
`;

const spinner = keyframes`
	from {
		opacity: 1;
	}

	to {
		transform: rotate(360deg);
		opacity: 1;
	}
`;

const scaleIn = keyframes`
	from {
		transform: scale(0.8) rotate(-120deg);
		opacity: 0;
	}

	to {
		opacity: 1;
	}
`;

export const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	animation: ${fadeInAndScale} 666ms ${timingFunctions('easeOutExpo')} 1;
`;

export const Spinner = styled.span`
	width: ${props => props.size}px;
	height: ${props => props.size}px;
	border-radius: 50%;
	border: ${props =>
		`${props.thickness || props.size / 12}px solid ${transparentize(
			0.666,
			props.color
		)}`};
	border-top-color: ${props => props.color};
	opacity: 0;
	animation: ${scaleIn} 200ms linear 1 ${props => props.delay}ms,
		${spinner} 600ms linear infinite ${props => props.delay + 200}ms;
	// After deployment, spinner is receiving extra style 'padding: 40px 20px 20px', adding style to nulify that style
	&& {
		padding: 0;
	}
`;

Spinner.propTypes = {
	color: PropTypes.string,
	delay: PropTypes.number,
	size: PropTypes.number,
	thickness: PropTypes.number,
};

Spinner.defaultProps = {
	color: brandColors.green,
	delay: 0,
	size: 46,
	thickness: 8,
};

export const Label = styled.span`
	margin-top: 16px;
	font-weight: bold;
	color: ${brandColors.green};
`;
